const filters = {
    id: null,
    search: null,
    status: null,
}

export default filters
